import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import CloseIcon from '../elements/icons/CloseIcon';
import Bars3Icon from '../elements/icons/Bars3Icon';

const MainMenu = () => {
  const location = useLocation();
  const currentRoute = location.pathname;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <div className='relative w-full bg-white xl:bg-gray-100 min-h-[60px] px-5 xl:px-32 2xl:px-44'>
      <div className='flex items-center justify-between py-3 lg:py-0'>
        <span className='font-medium text-sm text-gray-600 lg:hidden'>Menu</span>
        <button
          type='button'
          className='lg:hidden flex items-center justify-center w-10 h-10 text-vcm-purple'
          onClick={() => setIsMenuOpen((isOpen) => !isOpen)}
          aria-expanded={isMenuOpen}
          aria-controls='main-navigation'
          aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        >
          <div className='text-2xl leading-none' aria-hidden='true'>{
          isMenuOpen ? 
              <CloseIcon className='w-6 h-6' />
            : 
              <Bars3Icon className={`w-6 h-6`} />
          }</div>
        </button>
      </div>

      <div id='main-navigation' className={`${isMenuOpen ? 'flex' : 'hidden'} absolute left-0 right-0 top-full z-20 flex-col items-start justify-between bg-white lg:bg-gray-100 rounded-lg px-8 pb-3 shadow-md lg:static lg:flex lg:flex-row lg:items-center lg:bg-transparent lg:px-0 lg:pb-0 lg:shadow-none`}>
        <div className='w-full flex flex-col lg:flex-row items-start lg:items-center gap-3 lg:gap-x-6'>
      
          <NavLink onClick={closeMenu} to="/user/home"  className={`font-medium text-xl py-2 lg:py-0 lg:text-sm nav-button ${currentRoute.includes('user/home') ? 'text-vcm-purple' : 'text-gray-600'}`}>Home</NavLink>

          <NavLink onClick={closeMenu} to="/user/applications"  className={`font-medium  text-xl py-2 lg:py-0 lg:text-sm nav-button ${currentRoute.includes('user/applications') ? 'text-vcm-purple' : 'text-gray-600'}`}>Applications</NavLink>
          
          <NavLink onClick={closeMenu} to="/user/students" className={`font-medium text-xl py-2 lg:py-0 lg:text-sm nav-button ${currentRoute.includes('user/students') ? 'text-vcm-purple' : 'text-gray-600'}`}>Students</NavLink>

          {/* <button className='font-medium text-sm'>Events</button>
          <button className='font-medium text-sm'>Exeats</button> */}
          <NavLink onClick={closeMenu} to="/user/payments" className={`font-medium text-xl py-2 lg:py-0 lg:text-sm nav-button ${currentRoute.includes('user/payments') ? 'text-vcm-purple' : 'text-gray-600'}`}>Payments</NavLink>

          <NavLink onClick={closeMenu} to="/user/downloadables" className={`font-medium text-xl py-2 lg:py-0 lg:text-sm nav-button ${currentRoute.includes('user/downloadables') ? 'text-vcm-purple' : 'text-gray-600'}`}>Downloadables</NavLink>
          {/* <button className='font-medium text-sm'>Downloads</button> */}
        </div>
        <div className='px-3 py-3 mb-5 lg:mb-0 rounded-lg bg-gray-100 lg:py-0 lg:px-0 mt-3 lg:mt-0'>
          <p className='text-sm lg:text-right mt-3'>
            For support, call <a className='text-vcm-purple font-[550]' href='tel:+2348094358825'>+234 809 435 8825</a> or <a className='text-vcm-purple font-[550]' href='tel:+2348165843315'>+234 816 584 3315</a> or send an email to <a  className='text-vcm-purple font-[550]' href='mailto:admissions@vaatiacollege.com.ng'>admissions@vaatiacollege.com.ng</a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default MainMenu